import styled from 'styled-components'

export const Container = styled.div`
  animation-name: shakeX;
  animation-duration: 1s;
  animation-fill-mode: both;

  @keyframes shakeX {
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      transform: translate3d(10px, 0, 0);
    }
  }
`
